/**
 * Meadow Inventory Swap
 *
 * Darkwood urn is shown by default. Rosewood is hidden unless a
 * location is provided and the API reports rosewood is in stock.
 */
(function () {
  'use strict';


  var PROXY_BASE = '/apps/meadow';
  var SESSION_KEY_LOCATION = 'meadow_location';

  var ROSEWOOD_URN = '8415940772012';

  // Hide rosewood immediately so it never flashes.
  // Target both the grid item parent (collapses the slot) and the card-wrapper.
  var hideRosewoodStyle = document.createElement('style');
  hideRosewoodStyle.textContent =
    '.grid__item:has(> .card-wrapper[data-product-id="' + ROSEWOOD_URN + '"]) { display: none !important; }' +
    ' .card-wrapper[data-product-id="' + ROSEWOOD_URN + '"] { display: none !important; }';
  document.head.appendChild(hideRosewoodStyle);

  function getLocation() {
    var params = new URLSearchParams(window.location.search);
    var location = params.get('location') || sessionStorage.getItem(SESSION_KEY_LOCATION);
    if (params.get('location')) {
      sessionStorage.setItem(SESSION_KEY_LOCATION, params.get('location'));
    }
    return location;
  }

  function setProductVisible(productId, visible) {
    var cards = document.querySelectorAll('.card-wrapper[data-product-id="' + productId + '"]');
    for (var i = 0; i < cards.length; i++) {
      var el = cards[i].closest('.grid__item') || cards[i];
      el.style.display = visible ? '' : 'none';
      // Our CSS hides rosewood before Dawn's scroll-animation observer runs,
      // so the observer marks it offscreen (opacity: 0.01). Cancel the
      // animation on show so the card is immediately visible.
      if (visible && el.classList.contains('scroll-trigger')) {
        el.classList.remove('scroll-trigger--offscreen');
        el.classList.add('scroll-trigger--cancel');
      }
    }
  }

  async function init() {
    var location = getLocation();
    if (!location) return;

    try {
      var response = await fetch(
        PROXY_BASE + '/products?location=' + encodeURIComponent(location)
      );
      if (!response.ok) {
        console.error('[meadow-swap] Proxy request failed:', response.status);
        return;
      }
      var data = await response.json();
      if (!data || !data.products) return;

      // The API returns rosewood as-is when it is in stock, and darkwood with
      // swapped_from set when rosewood is out of stock.
      var rosewoodInStock = false;
      var swappedProduct = null;
      for (var i = 0; i < data.products.length; i++) {
        var product = data.products[i];
        var productId = product.product_id && product.product_id.split('/').pop();
        var swappedFrom = product.swapped_from;
        if (productId === ROSEWOOD_URN && !swappedFrom) {
          rosewoodInStock = true;
        }
        if (swappedFrom && swappedFrom.split('/').pop() === ROSEWOOD_URN) {
          swappedProduct = product;
        }
      }

      if (rosewoodInStock) {
        hideRosewoodStyle.parentNode.removeChild(hideRosewoodStyle);
        setProductVisible(ROSEWOOD_URN, true);
        return;
      }

      if (!swappedProduct) return;

      // If on the Rosewood product detail page, redirect to Darkwood
      if (document.querySelector('product-info[data-product-id="' + ROSEWOOD_URN + '"]')) {
        var redirectUrl = '/products/' + swappedProduct.handle;
        if (location) redirectUrl += '?location=' + encodeURIComponent(location);
        window.location.replace(redirectUrl);
      }
    } catch (err) {
      console.error('[meadow-swap] Error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
